<template>
  <!-- 楼层图片 -->
  <div class="floorImgs">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增图片</el-button
        >
        <el-button
          type="danger" 
          @click="handleDel()"
          >删除</el-button
        >
      </template>
    </page-header>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="请输入商品名称"
          v-model="searchForm.name"
        >
        </el-input>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" type="index" width="150">
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="编号"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        align="center"
        show-overflow-tooltip
        label="名称"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="pcLink"
        label="PC跳转链接"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <el-table-column
        prop="name"
        label="APP跳转类型"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{
          appTypeData[scope.row.name]
        }}</template>
      </el-table-column>
      <el-table-column
        prop="appName"
        label="APP跳转内容"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 1">已禁用</el-tag>
          <el-tag type="success" v-if="scope.row.status == 2">已启用</el-tag>
          <el-tag type="info" v-if="scope.row.status == 0">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.status != 0"
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-show="scope.row.status == 1"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 2)"
            >启用</el-button
          >
          <el-button
            v-show="scope.row.status == 2"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 1)"
            >禁用</el-button
          >
          <el-button
            v-show="scope.row.status != 0"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 0)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 编辑图片 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑图片</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="120px"
            :rules="addFormRule"
            ref="addForm"
          >
            <!-- <el-form-item label="选择级别" prop="rank">
              <el-select v-model="addForm.rank" placeholder="请选择" style="width:100%" @change="setSortRank">
                <el-option label="一级分类" value="1"></el-option>
                <el-option label="二级分类" value="2"></el-option>
                <el-option label="三级分类" value="3"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item
              v-show="addForm.rank == '2'"
              label="选择父级分类"
              prop="parentId"
            >
              <el-select
                v-model="addForm.parentId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in tableData"
                  :key="index"
                  :label="item.title"
                  :value="item.id + ''"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="addForm.rank == '3'"
              label="选择父级分类"
              prop="parentId"
            >
              <el-select
                v-model="addForm.parentId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in twoList"
                  :key="index"
                  :label="item.title"
                  :value="item.id + ''"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="名称" prop="title">
              <el-input v-model="addForm.title"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="icon">
              <upload
                @fileChange="uploadSortImg"
                accept="image/jpg,image/jpeg,image/png"
                :multiple="true"
              ></upload>
              <img-view
                style="margin-left: 20px"
                :imgList="[{ url: sortImg, id: 0 }]"
              ></img-view>
            </el-form-item>
            <!-- <el-form-item v-show="addForm.rank == '1'" label="跳转路径" prop="name">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="PC跳转链接" prop="pcLink">
              <el-input v-model="addForm.pcLink"></el-input>
            </el-form-item> -->
            <el-form-item label="APP跳转类型" prop="appType">
              <el-select
                v-model="addForm.appType"
                placeholder="跳转类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in $store.state.APP_TYPE_LIST"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="商品编号"
              prop="appGoods"
              v-show="addForm.appType == '1'"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appGoods"
                readonly
                placeholder="单击选择"
                @click.native="getGoodsSelectList('')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="跳转模块"
              prop="appMode"
              v-if="addForm.appType == '2'"
              class="el-form-required-true"
            >
              <el-select
                v-model="addForm.appMode"
                placeholder="跳转模块"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in appModeList"
                  :key="item.Id"
                  :label="item.title"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="网页链接"
              prop="appWebUrl"
              v-show="addForm.appType == '3'"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appWebUrl"
                clearable
                placeholder="网页链接"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="商品分类"
              prop="appGoodsSort"
              v-show="addForm.appType == '4'"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appGoodsSortName"
                placeholder="单击选择"
                readonly
                @click.native="getGoodsSort('')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="列表"
              prop="appMode"
              v-if="addForm.appType == '5'"
              class="el-form-required-true"
            >
              <el-select
                v-model="addForm.appExpert"
                placeholder="列表"
                style="width: 100%"
              >
                <el-option
                  v-for="item in appExpertList"
                  :key="item.Id"
                  :label="item.title"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="首页视频"
              prop="appVideo"
              v-if="addForm.appType == '6'"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appVideoName"
                placeholder="单击选择首页视频"
                readonly
                @click.native="getVideoList('')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="首页图文"
              prop="appImageText"
              v-if="addForm.appType == '7'"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appImageTextName"
                placeholder="单击选择首页图文"
                readonly
                @click.native="getImageTextList('')"
              ></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="addForm.sort"
                style="width: 100%"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <!-- 商品表格 -->
    <el-dialog
      title="商品列表"
      :visible.sync="goodsDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入商品名称"
            v-model="goodsName"
            @keydown.native.enter="getGoodsList(1)"
          >
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getGoodsList(1)"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="goodsList"
        border
        tooltip-effect="dark"
        height="300px"
        :row-class-name="tableRowClassName"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="code"
          align="center"
          width="160"
          show-overflow-tooltip
          label="商品编号"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          width="160"
          show-overflow-tooltip
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          prop="entname"
          align="center"
          show-overflow-tooltip
          label="机构名称"
        >
        </el-table-column>
        <el-table-column
          prop="specification"
          label="商品规格"
          width="120"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="packingNnit"
          label="包装单位"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="producer"
          label="生产厂家"
          width="120"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <!-- 使用返回的类名判断，和表格的方法一样 -->
            <el-button
              v-if="tableRowClassName(scope) != ''"
              type="danger"
              style="padding: 2px 3px"
              plain
              @click="handleDelGoods(scope)"
              >删除</el-button
            >
            <el-button
              v-else
              type="primary"
              style="padding: 2px 3px"
              plain
              @click="handleGoodsItem(scope)"
              >添加</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"
      ></pagination>
      <!-- <div slot="footer">
        <el-button type="warning" @click="handleResetGoods">清空</el-button>
        <el-button type="primary" @click="handleSubmitGoods">提交</el-button>
      </div> -->
      
    </el-dialog>

    <!-- 数据选择 -->
    <tableDialog
      v-if="goodsSort.isShow"
      title="商品分类(二级分类)"
      :tableData="goodsSort.tableData"
      :tableHead="goodsSort.tableDataHead"
      :currPage.sync="goodsSort.currPage"
      :allPage="goodsSort.allPage"
      @search="getGoodsSort"
      @rowClick="goodsSortSel"
      @hanCurrChange="goodsSortPage"
      @close="goodsSort.isShow = false"
    ></tableDialog>

    <!-- 商品编号选择弹窗 -->
    <tableDialog
      v-if="goodsSelectDialog.isShow"
      title="商品编号"
      :tableData="goodsSelectDialog.tableData"
      :tableHead="goodsSelectDialog.tableDataHead"
      :currPage.sync="goodsSelectDialog.currPage"
      :allPage="goodsSelectDialog.allPage"
      @search="getGoodsSelectList"
      @rowClick="goodsSelect"
      @hanCurrChange="goodsPageChange"
      @close="goodsSelectDialog.isShow = false"
    ></tableDialog>


    <!-- 视频选择弹窗 -->
    <tableDialog
      v-if="videoDialog.isShow"
      title="首页视频"
      :tableData="videoDialog.tableData"
      :tableHead="videoDialog.tableDataHead"
      :currPage.sync="videoDialog.currPage"
      :allPage="videoDialog.allPage"
      @search="getVideoList"
      @rowClick="videoSelect"
      @hanCurrChange="videoPageChange"
      @close="videoDialog.isShow = false"
    ></tableDialog>

    // 图文选择弹窗
    <tableDialog
      v-if="imageTextDialog.isShow"
      title="首页图文"
      :tableData="imageTextDialog.tableData"
      :tableHead="imageTextDialog.tableDataHead"
      :currPage.sync="imageTextDialog.currPage"
      :allPage="imageTextDialog.allPage"
      @search="getImageTextList"
      @rowClick="imageTextSelect"
      @hanCurrChange="imageTextPageChange"
      @close="imageTextDialog.isShow = false"
      ></tableDialog>
  </div>
</template>

<script>
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "floorImgs",
  data() {
    return {
      entId: "", //机构id
      /**表格数据 */
      tableData: [],
      selectedList: [], //选中的商品
      /**搜索表单 */
      searchForm: {
        name: "",
        status: "2",
        // type: "",
      },
      goodsSearchForm: {
        classify: "",
        attr: "",
        status: "9",
        stock: "",
        pic: "",
        activityArea: "",
        activityStatus: "",
        name: "",
        startdate: "",
        enddate: "",
      },

      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**批量绑定商品 */
      addGoodsForm: {
        name: "", //分类名称
        id: "", //分类id
        list: [], //{id、name}
      },
      goodsName: "", //检索使用，商品名称
      goodsDialog: false, //dialog
      goodsList: [], //商品列表
      goodsData: {}, //商品数据
      /**分页数据 */
      currPage2: 1,
      pageSize2: 20,
      allPage2: 0,

      // 二级分类列表
      twoList: [],
      appTypeData: {
        0: "无跳转",
        1: "商品详情",
        2: "跳转模块",
        3: "网页链接",
        4: "商品分类",
        5: "专区商品",
        6: "首页视频",
        7: "首页图文"
      },
      appModeList: [], // 模块列表
      appModeData: {}, // 模块数据
      goodsSortData: {}, // 分类数据
      appExpertList: [], // 专区列表
      appExpertData: {}, // 专区数据
      videoList: [],
      videoData: {}, // 视频数据
      imageTextList: [], 
      imageTextData: {}, // 图文数据
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        id: 0,
        title: "",
        rank: "1",
        sort: 1,
        status: 2,
        channelId: 1,
        parentId: "0",
        name: "",
        icon: "",
        navType: "",
        pcLink: "",
        appType: "0",
        appGoods: "",
        appGoodsName: "", //商品编号名称
        appMode: "",
        appWebUrl: "",
        appGoodsSort: "",
        appGoodsSortName: "",
        appExpert: "",
        appName: "",
        appVideo: "", //首页视频
        appVideoName: "", //首页视频名称
        appImageText: "", //首页图文
        appImageTextName: "", //首页图文名称
      },
      sortImg: "", // 分类图片，用于本地显示
      addFormRule: {
        rank: [mustFill],
        parentId: [mustFill],
        title: [mustFill],
        icon: [mustFill],
        sort: [mustFill],
        appType: [mustFill], // 移动端跳转类型
        appGoods: [this.appLinkFill("appType", "1")], // 移动端商品编号
        appMode: [this.appLinkFill("appType", "2")], // 移动端跳转模块
        appWebUrl: [this.appLinkFill("appType", "3")], // 移动端跳转网页
        appGoodsSort: [this.appLinkFill("appType", "4")], // 移动端商品分类
        appExpert: [this.appLinkFill("appType", "5")], // 移动端专区编号
        appVideo: [this.appLinkFill("appType", "6")], // 移动端首页视频
        appImageText: [this.appLinkFill("appType", "7")], // 移动端首页图文
      },
      // 商品分类弹窗
      goodsSort: {
        isShow: false,
        name: "",
        tableData: [],
        tableDataHead: {},
        currPage: 1,
        allPage: 1,
      },
      // 商品编号弹窗
      goodsSelectDialog: {
        isShow: false,
        name: "",
        tableData: [],
        tableDataHead: {},
        currPage: 1,
        allPage: 1,
      },
      // 首页视频弹窗
      videoDialog: {
        isShow: false,
        name: "",
        tableData: [],
        tableDataHead: {},
        currPage: 1,
        allPage: 1,
      },
      // 首页图文弹窗
      imageTextDialog: {
        isShow: false,
        name: "",
        tableData: [],
        tableDataHead: {},
        currPage: 1,
        allPage: 1,
      },
    };
  },
  mounted() {
    // 接收路由跳转传递的参数
    if ("id" in this.$route.query) {
      this.addGoodsForm.id = this.$route.query.id;
      this.addGoodsForm.name = this.$route.query.title;
      this.addForm.navType = this.$route.query.navType;
    }
    this.entId = window.localStorage.getItem("entId");
    this.getTableData(1);
    this.getMode();
    this.getVideoData();
    this.getImageTextData();
  },
  methods: {
    /**返回 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },

    handleSearch() {
      this.getTableData(1);
    },
    updata() {
      this.getMode();
    },

    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },

    getTableData() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        navType: this.addForm.navType,
        status: this.searchForm.status,
      };
      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.changeArr(res.list || []);
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
     /**递归调用函数 */
     changeArr(list) {
      let obj = {};
      obj[0] = [];
      let twoList = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let itemData = this.setTabelItem(item);
        if (item.rank == 1) {
          obj[0].push(itemData);
        } else {
          if (!obj[item.parent_id]) {
            obj[item.parent_id] = [];
          }
          if (item.rank == 2) {
            twoList.push(itemData);
          }
          obj[item.parent_id].push(itemData);
        }
      }
      for (let i = 0; i < obj[0].length; i++) {
        obj[0][i].childs = obj[obj[0][i].id];
        delete obj[obj[0][i].id];
      }
      for (let i = 0; i < twoList.length; i++) {
        twoList[i].childs = obj[twoList[i].id];
      }
      this.allPage = obj[0].length;
      this.tableData = obj[0];
      this.twoList = twoList;
    },
    // 设置表格数据格式
    setTabelItem(item) {      
      let appName = "无";
      if (item.name == 1 || item.name == 3) {
        appName = item.link_url || "无";
      } else if (item.name == 2) {
        appName =
          (this.appModeData[item.link_url] &&
            this.appModeData[item.link_url].title) ||
          "无";
      } else if (item.name == 4) {
        appName =
          (this.goodsSortData[item.link_url] &&
            this.goodsSortData[item.link_url]["分类"]) ||
          "无";
      } else if (item.name == 5) {
        appName =
          (this.appExpertData[item.link_url] &&
            this.appExpertData[item.link_url].title) ||
          "无";
      }  else if (item.name == 6) {
        appName =
          (this.videoData[item.link_url] &&
            this.videoData[item.link_url].name) ||
          "无";          
      }  else if (item.name == 7) {
        appName =
          (this.imageTextData[item.link_url] &&
            this.imageTextData[item.link_url].name) ||
          "无";          
      } 
      return {
        id: item.Id,
        title: item.title,
        rank: item.rank + "",
        sort: item.sort_id,
        status: item.status,
        channelId: item.channel_id,
        parentId: item.parent_id + "",
        name: item.name,
        pcLink: item.url,
        appType: item.name,
        appGoods: item.name == 1 ? item.link_url : "",
        appMode: item.name == 2 ? item.link_url : "",
        appWebUrl: item.name == 3 ? item.link_url : "",
        appGoodsSort: item.name == 4 ? item.link_url : "",
        appGoodsSortName: item.name == 4 ? appName : "",
        appExpert: item.name == 5 ? item.link_url : "",
        appVideo: item.name == 6 ? item.link_url : "",
        appVideoName: item.name == 6 ? appName : "",
        appImageText: item.name == 7 ? item.link_url : "",
        appImageTextName: item.name == 7 ? appName : "",
        appName: appName,
        icon: item.icon_url,
        navType: item.nav_type,
        childs: [],
      };
    },
    // 获取可跳转模块
    getMode() {      
      let data = {
        entId: window.localStorage.getItem("entId"),
        navType: "APPLink",
        status: 2,
      };
      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "Post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.appModeList = res.list || [];
            this.appModeData = this.$arrToObj(this.appModeList, "name");
          }
          this.getGoodsSortAll();
        })
        .catch((err) => {
          window.console.log(err);
          this.getGoodsSortAll();
        });
    },
    // 获取所有商品分类
    getGoodsSortAll() {
      let data = {
        type: "CategrysListHG",
        PageIndex: 1,
        PageSize: 10000,
        strWhere: "",
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      let url =
        "ashx/MainReturnJson.ashx?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&type=" +
        type +
        "&proc=" +
        proc;
      this.$requestSys({
        method: "post",
        url: url,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsSortData = this.$arrToObj(res.content || [], "keyid");
          }
          this.getExpert();
        })
        .catch((err) => {
          window.console.log(err);
          this.getExpert();
        });
    },
    // 获取专区列表
    getExpert() {      
      let data = {
        entId: window.localStorage.getItem("entId"),
        navType: "ExpertList",
        status: 2,
      };
      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "Post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.appExpertList = res.list || [];
            this.appExpertData = this.$arrToObj(this.appExpertList, "name");
          }
          this.getTableData();
        })
        .catch((err) => {
          window.console.log(err);
          this.getTableData();
        });
    },

    // 获取视频列表
    getVideoData() {
      let data = {
        entid: localStorage.getItem("entId"),
        category: "445",
        channelId: "20",
        status: this.searchForm.status,
        name: this.searchForm.name,
        // startDate: this.searchForm.start ? this.searchForm.start.split('T')[0] : '',
        // endDate: this.searchForm.end ? this.searchForm.end.split('T')[0] : '',
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Article/GetPopularScience",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.videoData = {};
            (res.list || []).forEach((item) => {               
              this.videoData[item.Img_url] = {
              id: item.Id,
              name: item.Title,
              classify: item.Category,
              sortId: item.Sort_Id,
              link_url:item.Img_url,
              }
            });  
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取所有视频分类
    getVideoDataAll() {
      let data = {
        entid: localStorage.getItem("entId"),
        category: "445",
        channelId: "20",
        status: this.searchForm.status,
        name: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Article/GetPopularScience",
        data: data,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.videoData = this.$arrToObj(res.content || [], "keyid");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 获取图文列表
    getImageTextData() {
      let data = {
        entid: localStorage.getItem("entId"),
        category: "446",
        channelId: "20",
        status: this.searchForm.status,
        name: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Article/GetPopularScience",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.imageTextData = {};
            (res.list || []).forEach((item) => { 
              this.imageTextData[item.Id] = {
              id: item.Id,
              name: item.Title,
              classify: item.Category,
              sortId: item.Sort_Id,
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
     // 获取所有图文分类
     getImageTextDataAll() {
      let data = {
        entid: localStorage.getItem("entId"),
        category: "446",
        channelId: "20",
        status: this.searchForm.status,
        name: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Article/GetPopularScience",
        data: data,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.imageTextData = this.$arrToObj(res.content || [], "keyid");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    // 选择数据事件
    selectionChange(section) {
      this.selectedList = section;
    },

    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getGoodsList();
    },
    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodsList();
    },

    /********* 商品添加 ***********/
    // /**打开商品列表弹框 */
    // handleChooseGoods() {
    //   this.goodsDialog = true;
    //   this.addGoodsForm.list = [];
    // },

    /**选中某一个商品 */
    handleGoodsItem({ row }) {
      // 判断数组中是否存该条数据
      let repeat = this.addGoodsForm.list.some((item) => item == row.id);
      if (repeat) {
        this.$message({
          message: "该商品已存在",
          type: "warning",
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          duration: 1000,
        });
        this.addGoodsForm.list.push(row.articleId);
      }
    },

    /**清空添加的商品 */
    handleResetGoods() {
      this.$confirm("确定清空吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.addGoodsForm.list = [];
        })
        .catch((e) => {
          console.log(e);
        });
    },
    changeBlue(item) {
      this.$confirm("确定修改排序吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            floorId: this.addGoodsForm.id,
            articleId: item.ArticleId,
            sortId: item.SortId,
          };

          this.$request({
            method: "post",
            url: "Management/GoodsAdmin/EditFloorGoodsSort",
            dataType: "json",
            data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "修改成功",
                  type: "error",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    /**删除选中的某一个商品 */
    handleDelGoods({ row }) {
      let index = this.addGoodsForm.list.indexOf(row.articleId);
      this.addGoodsForm.list.splice(index, 1);
    },

    /**获取商品数据 */
    getGoodsList(num) {
      this.currPage2 = num == 1 ? 1 : this.currPage2;
      let data = {
        type: "GoodsList",
        category: "0",
        attribute: "0",
        status: "2",
        strWhere: this.goodsName,
        PageIndex: this.currPage2,
        PageSize: this.pageSize2,
        promtype: "",
        promstatus: "99",
        goodsPic: "99",
        spStatus: "99",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage2 = res.recordCount;
          this.goodsList = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.goodsList.push({
                id: res.data[i].article_id,
                code: res.data[i].goodscode,
                name: res.data[i].sub_title,
                entname: res.data[i].entname,
                entid: res.data[i].entId,
                specification: res.data[i].drug_spec,
                packingNnit: res.data[i].package_unit,
                producer: res.data[i].drug_factory,
                classify: res.data[i].category,
                repertory: res.data[i].stock_quantity,
                retailPrice: res.data[i].price,
                validTime: res.data[i].valdate,
                articleId: res.data[i].article_id,
                organId: res.data[i].adminentid,
                status: res.data[i].status,
                sort: res.data[i].sort_id,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**商品绑定 */
    /**提交商品信息 */
    handleSubmitGoods() {
      if (this.addGoodsForm.list.length == 0) {
        this.$message({
          message: "暂未绑定商品",
          type: "error",
        });
        return;
      }
      this.$confirm("确定提交吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request({
          method: "post",
          url: "/GoodsAdmin/SaveFloodGoodsToList",
          data: {
            entId: this.entId,
            floodId: this.addGoodsForm.id,
            goodsStr: this.addGoodsForm.list.join(),
          },
        })
          .then((res) => {
            let type = "success";
            if (res.success) {
              this.goodsDialog = false;
              this.addGoodsForm.list = [];
              this.getTableData(1);
            } else {
              type = "error";
            }

            this.$message({
              message: res.message,
              type,
            });
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },

    /**获取商品分类 */
    getGoodsSort(val, isRep) {
      this.goodsSort.name = isRep ? val : this.goodsSort.name;
      this.goodsSort.currPage = isRep ? 1 : this.goodsSort.currPage;
      let data = {
        type: "CategrysListHG",
        PageIndex: this.goodsSort.currPage,
        PageSize: 10,
        strWhere: this.goodsSort.name,
      };
      let proc = "Proc_Admin_SearchInfo"; // 存储过程名
      let type = "ReturnDataSet";
      let url =
        "ashx/MainReturnJson.ashx?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&type=" +
        type +
        "&proc=" +
        proc;
      this.$requestSys({
        method: "post",
        url: url,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsSort.isShow = true;
            this.goodsSort.tableData = res.content;
            this.goodsSort.tableDataHead = res.fdname;
            this.goodsSort.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    goodsSortPage(val) {
      this.goodsSort.currPage = val;
      this.getGoodsSort();
    },
    goodsPageChange(val) {
      this.goodsSelectDialog.currPage = val;
      this.getGoodsSelectList();
    },
    videoPageChange(val) {
      this.videoDialog.currPage = val;
      this.getVideoList();
    },
    imageTextPageChange(val) {
      this.imageTextDialog.currPage = val;
      this.getImageTextList();
    },
    // 商品编号选择完成
    goodsSelect(row) {
      this.addForm.appGoods = row.id;
      this.addForm.appGoodsName = row.name;
      this.goodsSelectDialog.isShow = false;
    },
    // 商品分类选择完成
    goodsSortSel(row) {
      this.addForm.appGoodsSort = row.keyid;
      this.addForm.appGoodsSortName = row["分类"];      
      this.goodsSort.isShow = false;
    },
    // 视频分类选择完成
    videoSelect(row) {      
      this.addForm.appVideo = row.link_url;
      this.addForm.appVideoName = row.title;
      this.videoDialog.isShow = false;
    },
    // 图片分类选择完成
    imageTextSelect(row) {
      this.addForm.appImageText = row.id;
      this.addForm.appImageTextName = row.title;
      this.imageTextDialog.isShow = false;
    },


    /**表格数据选中状态判断 */
    tableRowClassName({ row }) {
      if (this.addGoodsForm.list.indexOf(row.articleId) > -1) {
        return "success-row";
      }
      return "";
    },
    /* 获取商品编号 */
    getGoodsSelectList(val, isRep) {
      this.goodsSelectDialog.name = isRep ?  val : this.videoDialog.name;
      this.goodsSelectDialog.currPage = isRep ? 1 : this.goodsSelectDialog.currPage;
      let data = {
        type: "GoodsList",
        category: this.goodsSearchForm.classify || "0",
        attribute: this.goodsSearchForm.attr || "0",
        status: this.goodsSearchForm.status || "9",
        strWhere: this.goodsSearchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        startdate: this.goodsSearchForm.startdate,
        enddate: this.goodsSearchForm.enddate,
        promtype:
          this.goodsSearchForm.activityArea == "99"
            ? ""
            : this.goodsSearchForm.activityArea,
        // promstatus: this.goodsSearchForm.activityStatus || "99",
        stock_quantity: this.goodsSearchForm.activityStatus,
        goodsPic: this.goodsSearchForm.pic || "99",
        spStatus: this.goodsSearchForm.stock || "99",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsSelectDialog.tableData = (res.data || []).map((item) => ({
              id: item.article_id,
              code: item.goodscode,
              name: item.sub_title,
              entname: item.entname,
              entid: item.entId,
              specification: item.drug_spec,
              packingNnit: item.package_unit,
              producer: item.drug_factory,
              classify: item.category,
              repertory: item.stock_quantity,
              retailPrice: item.price,
              validTime: item.valdate,
              articleId: item.article_id,
              organId: item.adminentid,
              status: item.status,
              sort: item.sort_id,
              goods_no: item.goods_no,
              img_url: this.$setImgUrl(item.img_url),
              AutRemark: item.AutRemark,
              DisableTime: item.DisableTime,
              EnableTime: item.EnableTime,
            }));
            this.goodsSelectDialog.tableDataHead = {
              // goodscode:"商品编号",
              // img_url: "商品图片",
              name:"商品信息",
              repertory:"库存",
              // retailPrice:"零售价",
              validTime:"有效期",
              specification:"规格",
              producer:"生产厂家",
            };
            this.goodsSelectDialog.allPage = res.recordCount;
            this.goodsSelectDialog.isShow = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /* 获取首页视频 */
    getVideoList(val, isRep) {
      this.videoDialog.name = isRep ? val : this.videoDialog.name;
      this.videoDialog.currPage = isRep ? 1 : this.videoDialog.currPage;
      let data = {
        entid: localStorage.getItem("entId"),
        category: "445",
        channelId: "20",
        status: this.searchForm.status,
        name: this.searchForm.name,
        // startDate: this.searchForm.start ? this.searchForm.start.split('T')[0] : '',
        // endDate: this.searchForm.end ? this.searchForm.end.split('T')[0] : '',
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Article/GetPopularScience",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.videoDialog.tableData = (res.list || []).map((item) => ({
              id: item.Id,
              classify: item.Category,
              title: item.Title,
              main: item.zhaiyao,
              updateTime: item.Add_Time,
              status: item.Status,
              sortId: item.Sort_Id,
              link_url:item.Img_url,
            }));
            this.videoDialog.isShow = true;
            this.videoDialog.tableDataHead = {
              sortId:"排序",
              id:"ID",
              classify:"分类",
              title:"标题",
              main:"摘要",
              updateTime:"添加时间",
              status:"状态",
            };
            this.videoDialog.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /* 获取首页图文 */
    getImageTextList(val,isRep) {
      this.imageTextDialog.name = isRep ? val : this.imageTextDialog.name;
      this.imageTextDialog.currPage = isRep ? 1 : this.imageTextDialog.currPage;
      let data = {
        entid: localStorage.getItem("entId"),
        category: "446",
        channelId: "20",
        status: this.searchForm.status,
        name: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Article/GetPopularScience",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.imageTextDialog.tableData = (res.list || []).map((item) => ({
              id: item.Id,
              classify: item.Category,
              title: item.Title,
              main: item.zhaiyao,
              updateTime: item.Add_Time,
              status: item.Status,
              sortId: item.Sort_Id,
            }));
            this.imageTextDialog.isShow = true;
            this.imageTextDialog.tableDataHead = {
              sortId:"排序",
              id:"ID",
              classify:"分类",
              title:"标题",
              main:"摘要",
              updateTime:"添加时间",
              status:"状态",
            };
            this.imageTextDialog.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });

    },

    /**新增/编辑分类 */
    handleAdd(row) {      
      this.clearForm();
      if (row) {
        for (let key in this.addForm) {          
          this.addForm[key] = row[key];
        }
        this.sortImg = this.$setImgUrl(row.icon);
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = {
        id: 0,
        title: "",
        rank: "1",
        sort: 1,
        status: 2,
        channelId: 1,
        parentId: "0",
        name: "",
        icon: "",
        navType: this.addForm.navType,
        pcLink: "",
        appType: "0",
        appGoods: "",
        appWebUrl: "",
        appGoodsSort: "",
        appGoodsSortName: "",
        appExpert: "",
        appName: "",
        appVideo: "",
        appVideoName: "",
        appImageText: "",
        appImageTextName: "",
      };
      this.sortImg = "";
      this.addDrawer = false;
    },

    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        row = this.selectedList[0];
        this.handleStatus(row, 0);
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    // 更改状态
    handleStatus(row,status) {
      let tips = "确定要启用吗？";
      let type = "success";
      if (status == 2) {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == 1) {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == 0) {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            id: row.id,
            status: status,
          };
          this.$request({
            url: "Navigation/UpdateNavigationStatusDal",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    // 上传分类图片
    uploadSortImg(file) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "admin/ashx/UploadImg.ashx?type=UploadFile&fileType=Navigation",
          data: formData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.addForm.icon = res.message;
              this.sortImg = this.$setImgUrl(res.message);
              this.$message.success("图片上传成功");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let link = "";
          if (this.addForm.appType == "1") {
            link = this.addForm.appGoods;
          } else if (this.addForm.appType == "2") {
            link = this.addForm.appMode;
          } else if (this.addForm.appType == "3") {
            link = this.addForm.appWebUrl;
          } else if (this.addForm.appType == "4") {
            link = this.addForm.appGoodsSort;
          } else if (this.addForm.appType == "5") {
            link = this.addForm.appExpert;
          } else if (this.addForm.appType == "6") {
            link = this.addForm.appVideo;
          } else if (this.addForm.appType == "7") {
            link = this.addForm.appImageText;
          }
          let data = {
            entId: window.localStorage.getItem("entId"),
            Id: this.addForm.id,
            channel_id: this.addForm.channelId,
            icon_url: this.addForm.icon,
            nav_type: this.addForm.navType,
            name: this.addForm.appType,
            link_url: link,
            parent_id: this.addForm.parentId,
            rank: this.addForm.rank,
            sort_id: this.addForm.sort,
            status: this.addForm.status,
            title: this.addForm.title,
            url: this.addForm.pcLink,
          };

          this.$request({
            url: "Navigation/EditNavigation",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.clearForm();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    // 移动端跳转链接控制验证
    appLinkFill(key, keyValue) {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm[key] == keyValue) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
  },
};
</script>

<style scoped>
.floorImgs {
  width: 100%;
  height: 100%;
}

.couponView {
  width: 100%;
  height: 100%;
  list-style: none;
}

.couponView > li {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  list-style: none;
}

.couponTitle {
  display: inline-block;
  height: 40px;
  margin-right: 5px;
  font-size: 16px;
  color: #000;
  line-height: 40px;
}

.couponText {
  display: inline-block;
  height: 40px;
  margin-right: 5px;
  font-size: 16px;
  color: #ccc;
  line-height: 40px;
}
</style>
